/**
 * Centralized route path constants.
 *
 * IMPORTANT: This file must NEVER import from page files.
 * It exists to break the import chain so lazy-loaded pages
 * don't get pulled into the main bundle.
 */

// Auth
export const AuthRoutePath = '/';
export const ResetPasswordRoutePath = '/auth/reset-password/:token';

// Main pages
export const DashboardRoute = '/dashboard';
export const CustomersRoute = '/customers';
export const PackagesRoute = '/packages';
export const PosRoute = '/point-of-sale';
export const InvoicesRoute = '/invoices';
export const ManifestsRoute = '/manifests';
export const ScanInRoute = '/scan-in';
export const SmartScanRoute = '/smart-scan';
export const DeliveryRequestRoute = '/delivery-request';
export const LocalDeliveriesRoute = '/local-deliveries';
export const PackageRequestsRoute = '/package-requests';

// Communication
export const AssistantRoute = '/assistant';
export const CommunicationRoute = '/communication';
export const CommunicationLogsRoute = '/communication-logs';
export const WhatsappRoute = '/whatsapp';
export const MarketingRoute = '/marketing';
export const ReviewsGalleryRoute = '/reviews-gallery';
export const ExpensesRoute = '/expenses';
export const CustomsEstimatorRoute = '/customs-estimator';
export const TariffCodesRoute = '/tariff-codes';
export const MarketingAgentsRoute = '/marketing-agents';

// Warehouse
export const WarehouseRoute = '/warehouse';
export const WarehouseHubRoute = '/warehouse-hub';
export const ScanBonusReportRoute = '/scan-bonus-report';
export const WarehouseBillingRoute = '/warehouse-billing';
export const WAREHOUSE_INVOICES_ROUTE = '/warehouse-invoices';
export const InvoiceRequestsRoute = '/invoice-requests';
export const WarehouseInterestsRoute = '/warehouse-interests';
export const UnknownPackagesRoute = '/unknown-packages';
export const FulfillmentPartnersRoute = '/fulfillment-partners';
export const FulfillmentOrdersRoute = '/fulfillment-orders';
// Sub-courier side: contracts to sign + KYC to complete for the warehouses
// this courier is partner-linked to.
export const PartnerRequirementsRoute = '/partner-requirements';
// Warehouse side: KYC review + contract templates/sends for its partners.
export const PartnerComplianceRoute = '/partner-compliance';

// Admin
export const UsersRoute = '/users';
export const SettingsRoute = '/settings';
export const BillingRoute = '/billing';
export const CouriersRoute = '/couriers';
export const CourierDetailRoute = '/couriers/:id';
export const MigrationsRoute = '/migrations';
export const AuditLogsRoute = '/audit-logs';
export const OnboardingRoute = '/onboarding';
export const OnboardingTasksRoute = '/onboarding-tasks';

// HR & Payroll
export const AttendanceRoute = '/attendance';
export const AttendanceReportRoute = '/attendance-report';
export const ClockInRoute = '/clock-in';
export const PayrollRoute = '/payroll';
export const StaffRatesRoute = '/staff-rates';
export const PayslipsRoute = '/payslips';

// Customer management
export const CourierCustomersRoute = '/courier-customers';
export const CustomerIssuesRoute = '/customer-issues';
export const RewardsRoute = '/rewards';
export const CashOutRoute = '/cash-out';
export const ShopForMeRoute = '/shop-for-me';
export const ShopRoute = '/shop';
export const ShopCategoriesRoute = '/shop-categories';
export const ShopOrdersRoute = '/shop-orders';

// Blog
export const BlogPostsRoute = '/blog-posts';
export const BlogCategoriesRoute = '/blog-categories';

// Support
export const FaqManagementRoute = '/faq-management';
export const SupportTicketsRoute = '/support-tickets';
export const DevBoardRoute = '/dev-board';

// Other
export const ProfileRoute = '/profile';
export const UnauthorizedRoute = '/unauthorized';
export const HelpCenterRoute = '/help-center';
export const MoreRoute = '/more';
export const ChangelogRoute = '/changelog';
export const RefreshRoute = '/refresh';
